import React, { SVGProps } from 'react';

export const ExternalLinkIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 19,
  height = 18,
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 19 18"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.59111 0.162572L1.52499 3.11622L13.183 3.37718L0.196983 15.7946L2.23764 17.9287L15.2237 5.51128L14.9627 17.1693L17.9164 17.2354L18.2902 0.536372L1.59111 0.162572Z"
        fill="#3490FF"
      />
    </svg>
  );
};
